import React, { useEffect, useState } from "react";
import './ContactAccountsInfo.css';
import { IContactAccountsInfoProps } from './~types/ContactAccountsInfoProps';
import { useTranslation } from 'react-i18next';
import { IAccount } from "src/app/contact/~store/models/Account";
import { showErrorToastr } from "src/app/shared/helpers/toastr-helper/ToastrHelper";
import { Button, Table } from "reactstrap";
import ContactAccountItem from "./contact-account-item/ContactAccountItem";
import { AccountType } from "src/app/contact/~store/models/AccountType";
import ExternalSystemAccountItem from "./external-system-account-item/ExternalSystemAccountItem";
import { tryExtractHost } from "src/app/shared/helpers/url-helper/UrlHelper";

function ContactAccountsInfo(props: IContactAccountsInfoProps) {
    const { t } = useTranslation();
    const [isCreating, setCreating] = useState(false);
    const [accounts, setAccounts] = useState(props.contactAccounts);

    const [activeTab, setActiveTab] = useState(0);
    
    useEffect(() =>  {setAccounts(props.contactAccounts)}, [props.contactAccounts.length, props.contactId]);
    
    const _onSaveAccountHandler = (account: IAccount): boolean => {
        if (!account.login || !account.externalId || !account.contactId) {
            showErrorToastr(t('contact.errorSavingAccountWithoutData'));
            setCreating(true);
            return false;
        } else if (/^\s*$/.test(account.externalId) || /^\s*$/.test(account.login)) {
            showErrorToastr(t('contact.errorSavingAccountOnlyWithSpaces'));
            setCreating(true);
            return false;
        } else if (account.externalId.length > 50 || account.login.length > 50) {
            showErrorToastr(t('contact.errorSavingAccountCharactersEqualOrMore50'));
            setCreating(true);
            return false;
        } else if (/\s/.test(account.externalId)) {
            showErrorToastr(t('contact.errorSavingAccountIdWithSpaces'));
            setCreating(true);
            return false;
        }
        else {
            if(account.id === 0) {
                setCreating(false);
            }
            props.saveAccount(account);
            return true;
        }        
    }

    const _onDeleteAccountHandler = (accountId: number): void => {
        if(accountId === 0) {
            let accIndex = accounts.findIndex(a => a.id === accountId);
            accounts.splice(accIndex, 1)
            setAccounts(accounts);
            setCreating(false);
        } else {
            if (window.confirm(t('contact.sureDeleteAccount'))) {
                props.deleteAccount(accountId);
            }            
        }
    }

    const _changeTab = (tabIndex: number) => {
        setActiveTab(tabIndex);
    }

    return (
        <div className="contact-accounts-info__container">
            <div className="contact-accounts-info__header-tabs-container">
                <div className={"contact-accounts-info__header-tab " + (activeTab === 0 && 'active-tab')}
                    onClick={() => _changeTab(0)}>
                    {t('common.accounts')}
                </div>
                {
                    props.contactAccounts.filter(a => a.externalSystemLink).map(a => 
                        {
                            return (
                                <div key={a.id} className={"contact-accounts-info__header-tab " + (activeTab === a.id && 'active-tab')}
                                    onClick={() => _changeTab(a.id)}>
                                    {tryExtractHost(a.externalSystemLink!)}
                                </div>
                            )
                        }
                    )
                }
            </div>
            
            {
                activeTab === 0 ?
                (<Table className="contact-accounts-info__table">
                    <thead
                        className="contact-accounts-info__btn-header">
                        <tr>
                            <th>                
                                <Button disabled={props.contactId === 0}
                                    onClick={() => {
                                        if(!isCreating) {
                                            setAccounts([{id: 0, contactId: props.contactId, type: AccountType.Amo, isSelected: false} as IAccount, ...accounts]);
                                            setCreating(true);
                                        }
                                    }}>
                                    {t('contact.createNewAccounts')}
                                </Button>
                            </th>
                            <th></th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    {accounts.length > 0 &&     
                        <React.Fragment>
                        <thead>
                            <tr>
                                <th>{t('common.id')}</th>
                                <th>{t('common.login')}</th>
                                <th>{t('common.type')}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {accounts.map(val => {

                                return (
                                    <ContactAccountItem 
                                        key={val.id} 
                                        isCreating={isCreating}
                                        account={val}
                                        saveAccount={_onSaveAccountHandler}
                                        deleteAccount={_onDeleteAccountHandler} /> 
                                );
                            })}
                            {accounts.length <= 0 && <tr className="contact-accounts-info__no-records"><td>{t('contact.noRecords')}</td><td></td><td></td><td></td></tr>}
                        </tbody>
                        </React.Fragment>}
                </Table>) :
                <ExternalSystemAccountItem account={props.contactAccounts.find(a => a.id === activeTab)!} />
            }
        </div>
    )
}

export default ContactAccountsInfo;
